function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import styles from "./TextArea.module.sass";
const TextArea = props => {
  const {
    name,
    className,
    ...inputProps
  } = props;
  return /*#__PURE__*/React.createElement("label", {
    className: `${styles["container"]} ${className || ""}`
  }, /*#__PURE__*/React.createElement("h5", {
    className: styles["label"]
  }, name), /*#__PURE__*/React.createElement("textarea", _extends({
    className: styles["input"]
  }, inputProps)));
};
export default TextArea;